import React, { useEffect, useState } from 'react';
import { Navbar, Container, Button } from 'react-bootstrap';
import { IoArrowBack } from 'react-icons/io5';

const NavbarBackComp = ({ handleBack }) => {


    return (
        <Navbar className="bg-transparent" sticky="top">
            <Container>
                <Navbar.Brand>
                    <Button
                        variant="light"
                        className="rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                        style={{ width: "40px", height: "40px" }}
                        onClick={handleBack}
                    >
                        <IoArrowBack size={50} />
                    </Button>
                </Navbar.Brand>
                <Navbar.Text className="justify-content-end">
                    {/* Signed in as: <p onClick={clickedProfile}>{auth?.username}</p> */}
                </Navbar.Text>
            </Container>
        </Navbar>
    );
};

export default NavbarBackComp;
